import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'

import ui from '../ducks/ui'
import auth from './auth'
import events from '../ducks/events'
import front from '../../front/reducer'
import { reducer as entities } from '../ducks/entities'
import app from './app'
import messenger from './messenger'
import eventsFront from './events-front'
import eventsAdmin from './events-admin'
import groupsAdmin from './groups-admin'
import users from './users'
import filters from './filters'
import authForms from './auth-forms'
import onBoarding from './on-boarding'
import profile from './profile'
import timeline from './timeline'
import pageHeader from './page-header'
import errors from './errors'
import notFoundRoutes from './not-found-routes'
import sports from './sports'
import systemRedirect from './system-redirect'
import photoUpload from './photo-upload'
import sportVenuesFront from './sport-venues-front'
import locale from './locale'
import imageCropper from './image-cropper'
import apiChecker from './api-checker'
import sportMeta from './sport-profile'
import showTournamentsBanner from './tournaments-banner'

export default history => combineReducers({
    auth,
    ui,
    events,
    entities,
    messenger,
    app,
    front,
    eventsFront,
    eventsAdmin,
    groupsAdmin,
    users,
    filters,
    authForms,
    onBoarding,
    profile,
    timeline,
    errors,
    notFoundRoutes,
    pageHeader,
    sports,
    systemRedirect,
    photoUpload,
    sportVenuesFront,
    locale,
    imageCropper,
    apiChecker,
    sportMeta,
    showTournamentsBanner,
    router: connectRouter(history),
})
